import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";

import NewsDashboard from "@/modules/news/user/components/NewsDashboard";
import NewsSlider from "@/modules/news/user/components/NewsSlider";
import { fetchNewsListQueryOptions } from "@/modules/news/user/services";

export const Route = createFileRoute("/_panel/_news/news/")({
  beforeLoad: () =>
    ({
      crumb: [],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchNewsListQueryOptions()),
  component: Component,
});

function Component() {
  return (
    <div className="flex flex-col gap-8 px-2">
      <NewsSlider />
      <NewsDashboard />
    </div>
  );
}
